<template>
  <div :class="['flex', loaderClass]">
    <span :class="['block animate-spin rounded-full', loaderIconClass]" />
  </div>
</template>

<script>
export default {
  props: {
    loaderClass: {
      type: String,
      default: '',
    },
    loaderIconClass: {
      type: String,
      default: 'h-4 w-4 border-b-2 border-ma',
    },
  },
};
</script>
